<template>
	<div class="box">
		<div class="row">
			<div class="col-2"><label for="age">{{ $t('pax.age') }}</label></div>
			<div class="col-2"><label for="departement">{{ $t('pax.departement') }}</label></div>
			<div class="col-2"><label for="compatibilite">{{ $t('pax.compatibilite_minimum') }}</label></div>
			<div class="col-2"><label for="indicator">{{ $t('pax.indicateur_minimum') }}</label></div>
			<div class="col-2"><label for="general">{{ $t('pax.compatibilite_generale') }}</label></div>
		</div>
		<div class="row">
			<div class="col-2">
				<b-input id="age" type="text" v-model="age"/>
			</div>
			<div class="col-2">
				<e-select
                    v-model="cp_selected"
                    id="departement"
                    track-by="code"
                    label="label"
                    :options="all_cp"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-2">
				<e-select
                    v-model="grade_selected"
                    id="compatibilite"
                    :options="all_grades"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="option" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="singleLabel" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-2">
				<e-select
                    v-model="indicator_selected"
                    id="indicator"
                    :options="all_grades"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="option" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="singleLabel" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-2">
				<e-select
                    v-model="general_selected"
                    id="general"
                    :options="all_grades"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="option" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="singleLabel" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-2">
            	<button @click.prevent="submit" class="btn btn-block btn-primary">{{ $t('global.rechercher') }}</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<CustomTable
		            id_table="pax_compatibilite"
		            ref="pax_compatibilite"
		            :items="mares"
		            :busy.sync="table_busy"
		            primaryKey="mare.horse_id"
		            :hide_if_empty="true"
		            :hrefsRoutes="config_table_hrefs"
					:externSlotColumns="['color_badge', 'color_indicator', 'color_general']"
		        >
		            <template v-slot:[`custom-slot-cell(color_badge)`]="{ data }">
		            	<div :class="'tags-fill '+data.result.result_color_grade"></div>
		            	<!-- <div class="stallionGrade" :class="data.result.result_color_grade">
							<div class="row no-gutters align-items-center">
								<div class="col-12 text-center grade">
									<span :class="'bullet bullet-'+bullet" v-for="(bullet, key) in data.result.result_color_bullets" :key="key"><font-awesome-icon :icon="['fas', 'circle']"/></span>
								</div>
							</div>
						</div> -->
					</template>
					<template v-slot:[`custom-slot-cell(color_indicator)`]="{ data }">
		            	<div :class="'tags-fill '+data.result.result_genetic_indicator_color"></div>
					</template>
					<template v-slot:[`custom-slot-cell(color_general)`]="{ data }">
		            	<div :class="'tags-fill '+data.result.result_color_general"></div>
					</template>
		    	</CustomTable>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import PaxMixin from "@/mixins/Pax.js"
	import TiersMixin from "@/mixins/Tiers.js"
	import HorseMixin from "@/mixins/Horse.js"
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'PaxCompatibilites',
		mixins: [PaxMixin, TiersMixin, HorseMixin, Navigation],
		props: ['horse_id'],
		data () {
			return {
				age: '',
				all_cp: [],
				cp_selected: '',
				all_grades: ['dark_green','green','yellow','orange','red'],
				grade_selected: null,
				indicator_selected: null,
				general_selected: null,
				config_table_hrefs: {
					'mare.horse_nom': {
						routeUniqueName: 'MareFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'mare.horse_id'
						}
					}
				},
				table_busy: false,
				mares: [],
				events_tab: {
					"TableAction::goToPrintSimulation": (mare) => {
						this.printSimulationCroisement(mare.mare.horse_id, this.horse_id)
					},
					"TableAction::goToAskIndice": this.addHorsesIndiceQueue
				}
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.all_cp = await this.getTiersCodePostal()
			},
			async submit() {
				this.table_busy = true
				const cp = this.cp_selected ? this.cp_selected.code : ''
				const mares = await this.getStallionCompatibilite(this.horse_id, this.age, cp, this.grade_selected, this.indicator_selected, this.general_selected)
				this.mares = mares.map(mare => ({
					...mare,
					phones_number: this.getArrayObjProperty(mare.tiers.phones, "phone_combine").join("<br>")
				}))
				this.table_busy = false
			}
		},

		components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>